import { gql } from '@apollo/client';

export const PayrollTokenFragment = gql`
  fragment PayrollToken on PayrollToken {
    id
    createdAt
    payrollProvider
    finchScopeType
  }
`;
